// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__aEnpT","notes":"Notes_notes__3i5rL","note":"Notes_note__11os_","markdown":"Notes_markdown__27w6t"};